import React, { Suspense, lazy } from "react";

// GraphiQL — graphiql + codemirror + the graphql-language-service/@graphql-tools tooling
// (~16 MB of source) and the crypto-browserify polyfill that tooling transitively pulls in —
// is only used on the docs API Explorer page. ApiExplorer used to be imported statically into
// client-bundle.js, so all of that shipped in the bundle that loads on EVERY page, including the
// embedded Shopify app's loading screen (which never uses it). Lazy-loading moves GraphiQL and
// its dependencies into a separate async chunk that only downloads when the explorer mounts.
const ApiExplorer = lazy(() => import("./ApiExplorer"));

// Type-only `import()` — erased at compile time, so referencing the prop types here does NOT
// pull ApiExplorer (or GraphiQL) back into this chunk.
type Props = React.ComponentProps<typeof import("./ApiExplorer").default>;

export default function LazyApiExplorer(props: Props) {
  return (
    <Suspense fallback={<div>Loading API Explorer…</div>}>
      <ApiExplorer {...props} />
    </Suspense>
  );
}
